export default __webpack_public_path__ + "static/template-team-member-3-94facf37ed1c3639c2e5b12c7616e133.jpg";